import { render, staticRenderFns } from "./AccountSecondaryCustomers.vue?vue&type=template&id=59751082&scoped=true&"
import script from "./AccountSecondaryCustomers.vue?vue&type=script&lang=js&"
export * from "./AccountSecondaryCustomers.vue?vue&type=script&lang=js&"
import style0 from "./AccountSecondaryCustomers.vue?vue&type=style&index=0&id=59751082&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59751082",
  null
  
)

export default component.exports